var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4389 1.62225L18.2702 16.566C18.0309 17.6205 17.4077 17.883 16.5219 17.3865L11.6934 13.8285L9.36391 16.0695C9.10591 16.3275 8.89066 16.5428 8.3934 16.5428L8.74065 11.6258L17.6889 3.54C18.0782 3.1935 17.6042 3.00075 17.0844 3.348L6.0219 10.314L1.2594 8.823C0.223655 8.49975 0.204905 7.78725 1.4754 7.29L20.1032 0.113253C20.9657 -0.209997 21.7202 0.305253 21.4389 1.623V1.62225Z",
    fill: "white",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegram-icon.f7edeb35664aacb6ea6af9378668a848.svg";
export { ForwardRef as ReactComponent };